module.exports = __webpack_public_path__ + "static/media/google-icon.a4562583.svg";